import ViewportHandler from '@/utils/viewport/ViewportHandler'
import ViewportValues from '@/utils/viewport/ViewportValues'
let handler = new ViewportHandler()
let values = new ViewportValues()
const mixin = {
  data () {
    return {
      viewport: {}
    }
  },
  methods: {
    setViewport (newViewport) {
      this.viewport = newViewport
    },
    destroyViewport () {
      handler.removeFn(this.setViewport)
    }
  },
  beforeMount () {
    handler.onChange = this.setViewport
    values.setValues()
    this.viewport = values.viewport
  },
  beforeDestroy () {
    this.destroyViewport()
  }
}
export default mixin



// WEBPACK FOOTER //
// ./src/mixins/MixinViewport.js